import { Helmet } from 'react-helmet-async';
import React, { useEffect, useState } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import { getProjectBySlug, resolveImageUrl } from '../../services/api';
import { projectsData } from '../../data/siteData';
import '../../styles/pages/ProjectDetail.css';

var bnrimg = require('./../../images/banner/1.jpg');


const DynamicProjectDetail = () => {
    const { id } = useParams();
    const [project, setProduct] = useState(null);

    useEffect(() => {
        let isMounted = true;
        const fetchDetail = async () => {
            const fallback = projectsData.find(item => String(item.id) === String(id) || item.slug === id) || projectsData[0];
            try {
                const apiData = await getProjectBySlug(id, fallback);
                if (isMounted) {
                    setProduct(apiData || fallback);
                }
            } catch (err) {
                if (isMounted) {
                    setProduct(fallback);
                }
            }
        };
        fetchDetail();
        return () => { isMounted = false; };
    }, [id]);

    const activeProj = project || projectsData[0];
    const rawImage = activeProj.mainImage || activeProj.image || '/images/products/acp_cladding.jpg';
    const formattedImg = resolveImageUrl(rawImage);
    const shortDesc = activeProj.summary || activeProj.description || `Architectural ${activeProj.category} project by bs clads.`;

    return (
        <>
            <Helmet>
                <title>bs clads</title>
                <meta name="description" content={shortDesc} />
                <meta property="og:title" content={`${activeProj.title} - bs clads Projects`} />
                <meta property="og:description" content={shortDesc} />
                <meta property="og:image" content={formattedImg} />
            </Helmet>
            <Header />
            <div className="page-content">
                <Banner
                    title={activeProj.title}
                    pagename={`Projects / ${activeProj.title}`}
                    description={shortDesc}
                    bgimage={bnrimg}
                />

                <div className="section-full p-tb80 bg-white">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 col-md-12 m-b30">
                                <div className="sx-post-media m-b30" style={{ borderRadius: '10px', overflow: 'hidden', minHeight: '350px', maxHeight: '500px' }}>
                                    <img src={formattedImg} alt={activeProj.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                </div>

                                <h2 className="m-b15" style={{ fontWeight: '800' }}>{activeProj.title}</h2>
                                <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#444' }} className="m-b30">
                                    {activeProj.description || activeProj.summary || `Architectural ${activeProj.category} elevation project executed by bs clads in Coimbatore.`}
                                </p>

                                {/* BACK TO PROJECTS BUTTON */}
                                <div>
                                    <NavLink to="/projects" className="site-button btn-half">
                                        <span>&larr; Back to All Projects</span>
                                    </NavLink>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-12">
                                <div className="p-a30 bg-dark text-white" style={{ borderRadius: '8px', backgroundColor: '#1a1a1a' }}>
                                    <h4 className="text-white m-t0 m-b20" style={{ borderBottom: '2px solid #f03a02', paddingBottom: '8px' }}>Project Information</h4>
                                    <ul className="list-unstyled" style={{ lineHeight: '2.4', color: '#ccc', fontSize: '15px' }}>
                                        <li><strong>Category:</strong> {activeProj.category || 'Architectural Elevation'}</li>
                                        {activeProj.clientName || activeProj.client ? <li><strong>Client:</strong> {activeProj.clientName || activeProj.client}</li> : null}
                                        <li><strong>Location:</strong> {activeProj.location || 'Coimbatore'}</li>
                                        <li><strong>Year:</strong> {activeProj.year || '2026'}</li>
                                    </ul>
                                    <div className="m-t20">
                                        <NavLink to="/contact-us" className="site-button btn-half">
                                            <span>Discuss Similar Project</span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default DynamicProjectDetail;
